/**
 * BrewNectar Cart — header icon drawer trigger + cart count sync
 */
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function updateHeaderCartCount(count) {
    if (typeof count !== 'number') return;

    document.querySelectorAll('[data-bn-cart-count]').forEach((el) => {
      if (count > 0) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });

    document.querySelectorAll('[data-bn-cart-count-suffix]').forEach((el) => {
      el.textContent = count > 0 ? ` (${count})` : '';
    });
  }

  function bindCartOpenTriggers() {
    const drawer = getDrawer();
    if (!drawer || typeof drawer.open !== 'function') return;

    const bind = (el) => {
      if (!el || el.dataset.bnCartBound === 'true') return;
      el.dataset.bnCartBound = 'true';
      el.setAttribute('role', 'button');
      el.setAttribute('aria-haspopup', 'dialog');

      el.addEventListener('click', (event) => {
        event.preventDefault();
        drawer.open(el);
      });

      el.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          drawer.open(el);
        }
      });
    };

    document.querySelectorAll('[data-bn-cart-open]').forEach(bind);
  }

  function subscribeCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const count = event?.cartData?.item_count;
      if (typeof count === 'number') {
        updateHeaderCartCount(count);
      }
    });
  }

  function syncCartContainerFromHeader() {
    const main = document.querySelector('main[data-template="cart"]');
    if (!main) return;

    const headerSection = document.querySelector('[data-bn-header-section]')?.closest('[id^="shopify-section-"]');
    if (!headerSection) return;

    const styles = getComputedStyle(headerSection);
    const max = styles.getPropertyValue('--bn-container-max').trim();
    const px = styles.getPropertyValue('--bn-container-px').trim();
    if (max) main.style.setProperty('--bn-cart-container-max', max);
    if (px) main.style.setProperty('--bn-cart-container-px', px);
  }

  function init() {
    bindCartOpenTriggers();
    subscribeCartUpdates();
    syncCartContainerFromHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
